module.exports = __webpack_public_path__ + "static/media/BG_Produk&Jasa.691b9327.jpg";